<template>
  <div class="not-found">
    <div class="not-found__message text-xs-center">
      <h1>
        <span class="primary--text">4</span>0<span class="primary--text">1</span>
      </h1>
      <h4>Esta acción esta restringida</h4>
      <v-btn color="primary" round  @click="back()"><v-icon dark>home</v-icon> Inicio</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back () {
      this.$router.push('/')
    }
  }
};
</script>

<style src="./pages.scss" lang="scss"></style>


// WEBPACK FOOTER //
// src/common/layout/pages/AppPermission.vue